import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

type Props = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const ChatContainerRoot = forwardRef<HTMLDivElement, Props>(function ChatContainerRoot(
  { children, className = "", ...props },
  ref
) {
  return (
    <div className={`pk-chat-root ${className}`} role="log" ref={ref} {...props}>
      {children}
    </div>
  );
});

export function ChatContainerContent({ children, className = "", ...props }: Props) {
  return (
    <div className={`pk-chat-content ${className}`} {...props}>
      {children}
    </div>
  );
}
